import React from 'react';
import {Text, Icon} from '@/ui-kits';
import {format} from 'date-fns';
import {SpecialistRecentPatient} from '@/interface';
import {ConsultationTypeLabels} from '@/constants';
import {cn, formatName} from '@/utils/common_functions';

interface RecentPatientsProps {
  patients: SpecialistRecentPatient[];
  className?: string;
}

export const RecentPatients: React.FC<RecentPatientsProps> = ({patients, className=''}) => {
  return (
    <div className={cn("border-2 border-gray-300 rounded-xl p-6 bg-ui_bg_pale_blue shadow-sm", className)}>
      {/* Header */}
      <div className="flex items-center gap-2 mb-5 flex-wrap min-w-0">
        <div className="flex items-center gap-2 min-w-0 flex-1">
          <div className="p-2 border-2 border-gray-100 rounded-lg bg-white flex-shrink-0">
            <Icon type="recent_user" className="text-ui_blue size-7" />
          </div>
          <Text variant="headingSemiBold" className="text-ui_blue break-words max-[374px]:!text-2xl min-w-0">
            Recent Patients
          </Text>
        </div>
      </div>

      {/* Patient List */}
      <div className="flex flex-col gap-3">
        {patients.map(patient => (
          <div
            key={patient.id}
            className="flex items-center justify-between p-4 bg-white rounded-lg border-2 border-gray-300 hover:bg-gray-50 transition-colors cursor-pointer shadow-sm">
            {/* Left - Patient Info */}
            <div className="flex flex-col gap-1 flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap min-w-0">
                <Text variant="title" className="text-ui_blue font-FigtreeSemiBold break-words !text-sm sm:!text-base min-w-0">
                  {formatName(patient.patient_name)}
                </Text>
                <Text className="text-ui_input_border_dark !text-xs sm:!text-sm whitespace-nowrap flex-shrink-0">
                  ( Case ID: <span className="font-FigtreeSemiBold">#{patient.id}</span> )
                </Text>
              </div>
              <Text className="text-ui_input_border_dark text-sm max-[325px]:whitespace-nowrap max-[325px]:!text-xs">
                {ConsultationTypeLabels[patient.case_type]} • {format(new Date(patient.case_created_at), 'd MMM yyyy')}
              </Text>
            </div>

            {/* Right - External Link Icon - Hidden on mobile */}
            {/* <button onClick={() => navigate(Routes.PATIENTS)} className="hidden sm:block">
              <Icon type="goto" className="text-ui_blue flex-shrink-0" />
            </button> */}
          </div>
        ))}
      </div>
    </div>
  );
};
